export const HIDE_INVOICES = 'hideInvoices';
export const ENABLE_MENU_MANAGEMENT = 'enableMenuManagement';
export const HIDE_MENU_MAPPING = 'hideMappingTab';
